import React from 'react';
import { ArticleProductProps } from '../components/ArticleProduct/ArticleProduct';
import { ArticleRichText, renderText } from '../components/ArticleRichText/ArticleRichText';
import { BLOCKS } from '@contentful/rich-text-types';
import { ContentfulProductSummary } from '@jbhi-fi/apis/src/contentful/types';

export const contentfulProductSummaryToArticleProductProps = ({
  fields,
}: ContentfulProductSummary): ArticleProductProps => {
  return {
    heading: fields?.heading ?? '',
    content: fields?.description ? (
      <ArticleRichText
        document={fields.description}
        renderOptions={{
          renderNode: {
            [BLOCKS.UL_LIST]: node => renderText(node, { paddingLeft: 8 }),
            [BLOCKS.OL_LIST]: node => renderText(node, { paddingLeft: 8 }),
          },
        }}
      />
    ) : null,
    productVariantId: fields?.product ?? '',
  };
};
